import _get from 'lodash/get'

export default {
  namespaced: true,
  state: {
    forms: {},
  },
  getters: {
    value: state => (id, field) => _get(state, `forms.${id}.${field}`, null),
  },
  mutations: {
    SET_FILTER(state, { id, data }) {
      state.forms[id] = data
    },
  },
  actions: {
    store(ctx, { id, data }) {
      ctx.commit('SET_FILTER', { id, data })
    },
  },
}
